import { create } from 'zustand';

const TYPING_TTL_MS = 4500;

type TypingState = {
  byChatId: Record<string, true>;
  setTyping: (chatId: string, isTyping: boolean) => void;
};

const timers = new Map<string, number>();

export const useTypingStore = create<TypingState>((set) => ({
  byChatId: {},
  setTyping: (chatId, isTyping) => {
    const timer = timers.get(chatId);

    if (timer) {
      window.clearTimeout(timer);
      timers.delete(chatId);
    }

    if (!isTyping) {
      set((state) => {
        if (!state.byChatId[chatId]) {
          return state;
        }

        const byChatId = { ...state.byChatId };
        delete byChatId[chatId];
        return { byChatId };
      });
      return;
    }

    set((state) => ({
      byChatId: { ...state.byChatId, [chatId]: true },
    }));
    timers.set(
      chatId,
      window.setTimeout(() => {
        useTypingStore.getState().setTyping(chatId, false);
      }, TYPING_TTL_MS),
    );
  },
}));
